import { render, staticRenderFns } from "./EmptyFireOutbreakList.vue?vue&type=template&id=a5a01138"
import script from "./EmptyFireOutbreakList.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyFireOutbreakList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports